export default __webpack_public_path__ + "media/flags/mu-562726ed.svg";